module.exports = __webpack_public_path__ + "img/ico-fb-circle.2761e8a9.svg";